export * from './template-manage.component';
